// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    zIndex: 9999,
    '& .MuiDialog-paper': {
      width: '30rem',
    },
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    alignItems: 'center',
    padding: theme.spacing(3, 3),
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: '20px',
    padding: 0,
    textTransform: 'none',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cancelButton: {
    color: theme.palette.grey[700],
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
  },
  buttonProgress: {
    color: '#777777',
  },
  dialogContent: {
    padding: theme.spacing(0, 3),
  },
  dialogText: {
    marginBottom: theme.spacing(2),
  },
});

export default styles;
